module.exports = __webpack_public_path__ + "img/osago-card.80cc5ce.png";